// extracted by mini-css-extract-plugin
export default {"socialsContainer":"Socials_socialsContainer__PYKru","icon":"Socials_icon__a30pt","bar":"Socials_bar__lZ3pw"};